"use strict";
var _ = require('underscore');
var bunsen = require('bunsen/libraries/bunsen');
var bubbleMatch = require('bubble-match');
var $ = require('dibs-jquery-shim');

/**
 * PresentationManager extracts the configuration of a view from a parent instance. Currently used for modals and tooltips.
 * @param {Boolean} options.reuse - if true, the modal will be re-used between opens and closes
 * @param {Backbone.View} options.parentView -  Backbone view that we are extending with a popModal-like interface. It should have a property identified by options.configGroup that maps keys for presentable views to the presentable view's configutacion object.
 * @param {String} options.viewConfigKey - key for the view that we will be presenting
 */

var PresentationManager = module.exports = function (options) {
    var configViewOptions;
    options = _.extend({
        configGroup: undefined,
        parentView: undefined, // the view that we are extending with a popModal-like interface
        viewConfigKey: undefined,
        reuse: false, // instead of creating a new modal, reuse the last modal if it exists
        viewOptions: {}
    }, options);
    this._configGroup = options.configGroup;
    this._parentView = options.parentView;
    this._viewConfigKey = options.viewConfigKey;
    this._disabled = options.disabled;
    if (!this._parentView) {
        throw new Error("options.parentView is required when building a PresentationManager");
    }
    if (!options.configGroup) {
        throw new Error("options.configGroup is required when building a PresentationManager");
    }
    configViewOptions = bunsen.result(this._parentView[options.configGroup], options.viewConfigKey, this._parentView);
    _.extend(options, _.pick(configViewOptions, 'reuse'));
    this._reuse = options.reuse;
    this._viewOptions = options.viewOptions;
    if (undefined === configViewOptions) {
        throw new Error("no config available for presentable view with key " + options.viewConfigKey);
    }
    this._viewOptions = _.extend({
        parentView: this._parentView
    }, configViewOptions, this._viewOptions);
};
var handleActivationEvent = function (viewType, handleGotKey, e) {
    // use BubbleMatch so this will still work if a child element of a [data-modal] was clicked
    var elUniqueAtttribute = 'data-' + viewType;
    var matchingEl = bubbleMatch({
        el: e.target,
        filter: '[' + elUniqueAtttribute + ']',
        parent: this.el
    });
    if (!matchingEl) {
        return;
    }
    // this.popModal($(matchingEl).attr(elUniqueAtttribute));
    handleGotKey.call(this, $(matchingEl).attr(elUniqueAtttribute), e);
    return false;
};
/**
 * construct (or retrieve from cache) the view that will be presented
 * @param {function(new:Backbone.View)} ViewConstructor - constructor for the view that will be returned
 */
PresentationManager.prototype.getView = function (ViewConstructor) {
    var cachedModal;
    if (bunsen.result(this, '_disabled', this._parentView)) {
        return;
    }
    var cacheKey = this._configGroup + "::" + this._viewConfigKey;
    cachedModal = this._reuse && _.result(this._parentView.__presentationCache__, cacheKey);
    if (cachedModal) {
        return cachedModal;
    }
    var view = new ViewConstructor(this._viewOptions);
    if (this._reuse) {
        if (!this._parentView.__presentationCache__) {
            this._parentView.__presentationCache__ = {};
        }
        this._parentView.__presentationCache__[cacheKey] = view;
    }
    return view;
};
PresentationManager.buildActivationEventHandler = function (options) {
    options = _.extend({
        dataAttribute: undefined,
        handleGotKey: undefined
    }, options);
    return _.partial(handleActivationEvent, options.dataAttribute, options.handleGotKey);
};



// WEBPACK FOOTER //
// ./~/bunsen/helpers/PresentationManager.es.js